import { render } from "./histories.vue?vue&type=template&id=1f99556d&scoped=true"
import script from "./histories.vue?vue&type=script&lang=js"
export * from "./histories.vue?vue&type=script&lang=js"

import "./histories.vue?vue&type=style&index=0&id=1f99556d&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/funfindhk20250610/front-vue-src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f99556d"]])

export default __exports__